export default {
  nav: {
    brand: "USFans Link",
    home: "Accueil",
    categories: "Catégories",
    guides: "Guides",
    faq: "FAQ",
    explore: "Explorer le tableau",
    shoppingGuide: "Guide d'achat",
  },
  hero: {
    eyebrow: "Centre de ressources USFans Spreadsheet",
    title: "Explorez USFans Spreadsheet : catégories, guides et ressources",
    description:
      "Découvrez un centre organisé dédié à USFans Spreadsheet : parcourez les catégories de mode, lisez des guides pratiques, comparez les ressources et trouvez tout ce dont vous avez besoin en un seul endroit calme et facile à naviguer.",
    trust: "Ressource indépendante • Mise à jour régulière • Navigation facile • Axée sur la sécurité",
    searchPlaceholder: "Recherchez créateurs, catégories, guides ou sujets...",
  },
  main: {
    usfansSpreadsheet: "USFans Spreadsheet",
    buyNow: "Acheter maintenant",
  },
  dropdown: {
    label: "Aller vers une catégorie",
    placeholder: "Choisissez une catégorie...",
  },
  categoriesSection: {
    title: "Parcourir les catégories",
    subtitle:
      "Explorez toute la gamme de catégories de mode et de style de vie, chacune menant à la section correspondante du site principal.",
    browseAll: "Voir toutes les catégories",
  },
  categories: {
    shoes: "Chaussures",
    hoodies: "Hoodies/Sweats",
    tshirts: "T-shirts",
    jackets: "Vestes",
    pants: "Pantalons/Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres",
  },
  what: {
    title: "Qu'est-ce que USFans Spreadsheet ?",
    p1: "USFans Spreadsheet est une ressource structurée qui facilite la découverte, la comparaison et la compréhension des informations liées à USFans. Au lieu de chercher sur des pages dispersées, vous pouvez explorer des catégories organisées couvrant les chaussures, les hoodies, les vestes, les accessoires et bien plus encore.",
    p2: "Il sert de point de départ convivial : parcourez la liste des catégories, choisissez ce qui vous intéresse, puis suivez un lien clair vers le site principal dès que vous êtes prêt à en voir davantage.",
    cta: "En savoir plus sur USFans Spreadsheet",
  },
  why: {
    title: "Pourquoi utiliser cette ressource ?",
    subtitle: "Une façon calme et organisée de naviguer, pensée pour la rapidité et la clarté.",
    c1title: "Informations organisées",
    c1desc: "Les catégories sont regroupées pour trouver la bonne section en quelques secondes.",
    c2title: "Découverte facile",
    c2desc: "Un menu déroulant simple et des boutons clairs rendent la navigation sans effort.",
    c3title: "Comparaisons utiles",
    c3desc: "Comparez les catégories côte à côte pour décider quoi explorer ensuite.",
    c4title: "Axé sur la sécurité",
    c4desc: "Des conseils clairs pour naviguer et suivre des liens en toute confiance.",
  },
  guides: {
    title: "Derniers guides",
    subtitle:
      "Des articles originaux et pratiques sur USFans Spreadsheet et la façon d'en tirer le meilleur parti.",
    readMore: "Lire le guide",
    comingSoon: "Bientôt disponible",
    comingTitle1: "USFans Review : ce qu'il faut savoir",
    comingExcerpt1: "Un regard plus précis sur les fonctionnalités, les avantages, les inconvénients et les points pratiques.",
    comingCategory1: "Avis",
    comingTitle2: "Guide des frais d'expédition USFans",
    comingExcerpt2: "Les facteurs d'expédition, les prix et les considérations de livraison expliqués.",
    comingCategory2: "Expédition",
  },
  faq: {
    title: "Questions fréquentes",
    subtitle: "Des réponses rapides aux questions courantes sur USFans Spreadsheet.",
    q1: "Qu'est-ce que USFans Spreadsheet ?",
    a1: "C'est une ressource structurée qui regroupe les catégories de mode et de style de vie dans une vue facile à parcourir, avec des liens clairs vers le site principal.",
    q2: "Comment parcourir les catégories ?",
    a2: "Utilisez le menu déroulant ou les boutons de catégories de la page d'accueil. Les deux mènent à la section correspondante du site principal.",
    q3: "USFans Spreadsheet est-il gratuit ?",
    a3: "Oui, la navigation est entièrement gratuite et ne nécessite aucun compte.",
    q4: "À quelle fréquence les informations sont-elles mises à jour ?",
    a4: "La ressource est actualisée régulièrement afin de garder les liens de catégories précis et à jour.",
    q5: "Où mènent les liens de catégories ?",
    a5: "Chaque lien mène à la section de catégorie correspondante du site principal.",
    q6: "Comment rester en sécurité en naviguant ?",
    a6: "Vérifiez l'adresse du site, gardez vos identifiants et données de paiement privés, et évitez de partager des informations personnelles avec des sources non fiables.",
  },
  cta: {
    title: "Commencez à explorer USFans Spreadsheet",
    desc: "Trouvez des catégories organisées, des guides pratiques et des ressources utiles en un seul endroit.",
    primary: "Explorer USFans Spreadsheet",
    secondary: "Visiter le site principal",
  },
  footer: {
    about:
      "USFans Link est un centre de ressources indépendant construit autour de USFans Spreadsheet, aidant les visiteurs à parcourir les catégories, lire des guides et trouver des informations utiles.",
    quickLinks: "Liens rapides",
    categories: "Catégories",
    resources: "Ressources",
    guides: "Guides",
    faq: "FAQ",
    home: "Accueil",
    rights: "Tous droits réservés.",
    disclaimer:
      "USFans Link est une ressource indépendante et n'est pas affilié au site principal. Les liens produits mènent à la boutique officielle.",
  },
  notFound: {
    title: "Page introuvable",
    desc: "La page que vous recherchez n'existe pas ou a été déplacée. Revenez à l'accueil pour continuer à naviguer.",
  },
};